import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HcFormField } from '@hotmart-org-ca/cosmos-web/dist/react/hc-form-field';
import { FieldLabel } from './label';
export function Field({ icon, valid, invalid, children, className, iconPosition, validMessage, invalidMessage, supportMessage, style }) {
    const hasMessage = validMessage || invalidMessage || supportMessage;
    return (_jsxs(HcFormField, { valid: valid, class: className, invalid: invalid, iconPosition: iconPosition, style: {
            ...(!hasMessage && { '--hc-form-field-message-margin-top': 0 }),
            ...style
        }, children: [children, _jsx("div", { slot: "valid-message", children: validMessage }), _jsx("div", { slot: "invalid-message", children: invalidMessage }), _jsx("div", { slot: "support-message", children: supportMessage }), icon && _jsx("div", { slot: "icon", children: icon })] }));
}
Field.Label = FieldLabel;
